import React from "react";
import PropTypes from "prop-types";
import {
  VIEW_COLUMNS,
  EDIT_COLUMNS,
} from "../../../config/deviceColumnsConfig";
import AddIcon from "@mui/icons-material/Add";

const DevicesTableHeader = ({ isEditMode, onAddNew }) => {
  const columns = isEditMode ? EDIT_COLUMNS : VIEW_COLUMNS;

  return (
    <tr className="sticky top-0 z-10">
      {isEditMode && (
        <th className="px-1 py-1">
          <button onClick={onAddNew} className="text-sss-blue-sel">
            <AddIcon />
          </button>
        </th>
      )}
      {columns.map((col) => (
        <th
          key={col.key}
          className="px-1 py-1 text-left font-medium text-sss-blue-sel whitespace-nowrap"
        >
          {col.label}
        </th>
      ))}
    </tr>
  );
};

DevicesTableHeader.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func,
};

export default DevicesTableHeader;
